import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import navIcon1 from "../assets/images/icons8-github.svg";
import navIcon2 from "../assets/images/icons8-google-scholar.svg";
import navIcon3 from "../assets/images/icons8-level-up-your-coding-skills-and-quickly-land-a-job-24.png";
import navIcon4 from "../assets/images/icons8-codeforces.-programming-competitions-and-contests,-programming-community.-24.png";
import navIcon5 from "../assets/images/icons8-linkedin.svg";

const socialLinks = [
  { href: "https://github.com/FariaRicha13", icon: navIcon1, label: "GitHub" },
  { href: "https://scholar.google.com/citations?user=GTFtcCsAAAAJ&hl=en", icon: navIcon2, label: "Google Scholar" },
  { href: "https://leetcode.com/FariaHabibRicha/", icon: navIcon3, label: "LeetCode" },
  { href: "https://codeforces.com/profile/fariaricha", icon: navIcon4, label: "Codeforces" },
  { href: "https://www.linkedin.com/in/faria-habib/", icon: navIcon5, label: "LinkedIn" },
];

export const Contact = () => {
  return (
    <section className="contact" id="contact">
      <Container>
        <TrackVisibility>
          {({ isVisible }) => (
            <div className={isVisible ? "animate__animated animate__fadeIn contact-inner" : "contact-inner"}>
              <span className="contact-label">Say Hello</span>
              <h2 className="contact-h2">Let's Connect</h2>
              <p className="contact-desc">
                Whether it's research, collaboration, or just a chat — my inbox is always open.
              </p>

              <Row className="justify-content-center g-4 contact-cards-row">
                <Col xs={12} md={5}>
                  <div className="contact-card">
                    <div className="contact-card-icon">✉️</div>
                    <h5>Email Me</h5>
                    <a href="mailto:fariahricha1301@gmail.com" className="contact-email">
                      fariahricha1301@gmail.com
                    </a>
                  </div>
                </Col>
                <Col xs={12} md={5}>
                  <div className="contact-card">
                    <div className="contact-card-icon">🌐</div>
                    <h5>Find Me Online</h5>
                    <div className="contact-socials">
                      {socialLinks.map((s, i) => (
                        <a
                          key={i}
                          href={s.href}
                          target="_blank"
                          rel="noreferrer"
                          className="contact-social-btn"
                          aria-label={s.label}
                        >
                          <img src={s.icon} alt={s.label} />
                        </a>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </TrackVisibility>
      </Container>
    </section>
  );
};
